module.exports = __webpack_public_path__ + "img/image10.bf99069b.png";